module.exports = __webpack_public_path__ + "img/bedroom_thumb.bff07ae5.jpg";